// Dink Supply: apply or remove a discount code on the cart page.
// Uses the Cart AJAX API's `discount` field (one code per order), then reloads
// so totals, the free-shipping bar and the discount list all refresh together.
if (!customElements.get('cart-discount')) {
  customElements.define(
    'cart-discount',
    class CartDiscount extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.input = this.querySelector('input');
        this.button = this.querySelector('button[type="submit"]');
        this.error = this.querySelector('.cart-discount__error');
        if (this.form) this.form.addEventListener('submit', this.onSubmit.bind(this));
        this.querySelectorAll('[data-remove-code]').forEach((el) =>
          el.addEventListener('click', this.onRemove.bind(this))
        );
      }

      async request(discount) {
        const response = await fetch(`${routes.cart_update_url}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount }),
        });
        return response.json();
      }

      async currentCodes() {
        const cart = await fetch(`${routes.cart_url}.js`).then((r) => r.json());
        return (cart.discount_codes || []).filter((d) => d.applicable).map((d) => d.code);
      }

      showError(message) {
        this.error.textContent = message;
        this.error.hidden = false;
      }

      setBusy(busy) {
        this.button.disabled = busy;
        if (!this.buttonLabel) this.buttonLabel = this.button.textContent;
        this.button.textContent = busy ? 'Applying…' : this.buttonLabel;
      }

      async onSubmit(event) {
        event.preventDefault();
        const code = this.input.value.trim();
        this.error.hidden = true;
        if (!code) return this.showError('Enter a discount code.');

        this.setBusy(true);
        try {
          const previous = await this.currentCodes();
          const cart = await this.request(code);
          const match = (cart.discount_codes || []).find((d) => d.code.toLowerCase() === code.toLowerCase());
          if (match && match.applicable) {
            window.location.reload();
            return;
          }
          // Not valid for this cart: put back whatever code was there before.
          await this.request(previous.join(','));
          this.showError("This code isn't valid for your cart, or has already been used.");
        } catch (e) {
          this.showError('Something went wrong. Please try again, or enter your code at checkout.');
        }
        this.setBusy(false);
      }

      async onRemove(event) {
        event.preventDefault();
        await this.request('');
        window.location.reload();
      }
    }
  );
}
